// Mock data for Mobyle website redesign

export const companyInfo = {
  name: "Mobyle",
  tagline: "Award-winning full-service digital agency",
  email: "hello@gomobyle.com",
  description: "We're a creative digital marketing and web design agency that crafts beautiful work for brands who refuse to blend in.",
  yearFounded: 2018,
  currentYear: 2025,
  social: {
    facebook: "https://www.facebook.com/gomobyle",
    instagram: "https://www.instagram.com/go.mobyle/",
    linkedin: "https://www.linkedin.com/company/gomobyle/"
  }
};

export const services = [
  {
    id: 1,
    title: "AI Solutions",
    subtitle: "Automation & Growth",
    description: "Automate your business with custom AI solutions to hyper grow your business.",
    features: ["AI Chatbots", "Process Automation", "Custom AI Tools", "AI Integration"],
    link: "/services/ai-solutions"
  },
  {
    id: 2,
    title: "Lead Generation",
    subtitle: "Growth & Acquisition",
    description: "Driving qualified leads to fuel your business growth with strategic campaigns that deliver measurable results.",
    features: ["Email Marketing", "Landing Pages", "CRM Integration", "Analytics"],
    link: "/services/lead-generation"
  },
  {
    id: 3,
    title: "AI Email Marketing",
    subtitle: "Outreach & Automation",
    description: "Power your email campaigns with Mobyle's advanced sending engine—designed to deliver high-volume outreach with precision targeting and consistently high deliverability powered by AI.",
    features: ["AI Agents", "High Deliverability", "Personalization", "Auto Follow-ups"],
    link: "/services/ai-email-marketing"
  },
  {
    id: 4,
    title: "Web Development",
    subtitle: "Design & Build",
    description: "Crafting digital experiences where beauty meets ROI, turning heads and unlocking revenue potential with every click.",
    features: ["Custom Websites", "E-Commerce", "WordPress", "Web Apps"],
    link: "/services/web-development"
  },
  {
    id: 5,
    title: "Social Media Marketing",
    subtitle: "Content & Strategy",
    description: "Building your brand presence across platforms with engaging content that sparks conversation and drives action.",
    features: ["Content Creation", "Community Management", "Influencer Outreach", "Analytics"],
    link: "/services/social-media"
  },
  {
    id: 6,
    title: "Digital Ads",
    subtitle: "Visibility & Performance",
    description: "Ads powered by exclusive high-intent data that target buyers actively searching for what you sell — right now.",
    features: ["Google Ads", "Meta Ads", "TikTok Ads", "LinkedIn Ads"],
    link: "/services/digital-ads"
  },
  {
    id: 7,
    title: "Videography & Photography",
    subtitle: "Visual Storytelling",
    description: "Creating stunning visual content that captures your brand essence and resonates with your audience.",
    features: ["Brand Videos", "Product Photography", "Social Content", "Drone Footage"],
    link: "/services/media-production"
  },
  {
    id: 8,
    title: "SEO",
    subtitle: "Search & Visibility",
    description: "Get found by people actively searching for what you offer. SEO strategies that drive traffic, leads, and long-term growth.",
    features: ["Keyword Research", "On-Page SEO", "Technical SEO", "Local SEO"],
    link: "/services/seo"
  },
];

export const portfolio = [
  {
    id: 1,
    client: "Air.ai",
    year: 2025,
    description: "Generated $11M in revenue through high-intent advertising campaigns.",
    services: ["High Intent Ads"],
    industry: "B2B Tech",
    image: "https://customer-assets.emergentagent.com/job_modern-gomobyle/artifacts/l1kpmbaq_1500-x-914-AI-Solutions-A-Guide-to-Getting-Started.jpg"
  },
  {
    id: 2,
    client: "TechFlow Solutions",
    year: 2025,
    description: "We crafted a dynamic web experience for a rising tech startup.",
    services: ["Web Design & Development", "Branding"],
    industry: "B2B Tech",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
  },
  {
    id: 2,
    client: "Coastal Realty Group",
    year: 2024,
    description: "Complete digital transformation for a premium real estate brand.",
    services: ["Branding", "Web Development", "Digital Marketing"],
    industry: "Real Estate",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80"
  },
  {
    id: 3,
    client: "FitLife Studios",
    year: 2024,
    description: "E-commerce platform and marketing campaigns for fitness brand.",
    services: ["E-Commerce", "Social Media", "Photography"],
    industry: "Health & Fitness",
    image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&q=80"
  },
  {
    id: 4,
    client: "Artisan Coffee Co.",
    year: 2024,
    description: "We completely transformed the image of a specialty coffee roaster.",
    services: ["Branding", "Web Development", "Photography"],
    industry: "Food & Beverage",
    image: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800&q=80"
  },
  {
    id: 5,
    client: "Summit Legal Partners",
    year: 2023,
    description: "Professional web presence for a prestigious law firm.",
    services: ["Web Design", "SEO", "Content Strategy"],
    industry: "Professional Services",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&q=80"
  }
];

export const results = [
  {
    id: 1,
    metric: "156%",
    description: "increase in qualified leads after 3 months.",
    project: "TechFlow Solutions"
  },
  {
    id: 2,
    metric: "89%",
    description: "rise in engaged sessions per user after 1 month.",
    project: "Coastal Realty"
  },
  {
    id: 3,
    metric: "245%",
    description: "increase in social media engagement after 6 months.",
    project: "FitLife Studios"
  },
  {
    id: 4,
    metric: "127%",
    description: "increase in organic traffic after 1 year.",
    project: "Artisan Coffee"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "Mobyle is amazing to work with! I have used Mobyle for years on many projects and would highly recommend! Their knowledge and experience is the best!",
    author: "Angie B.",
    role: "Business Owner",
    project: "Multiple Projects"
  },
  {
    id: 2,
    quote: "The team at Mobyle created exactly what I wanted, and also suggested some very helpful tools I was not even aware of. Then I got a 1-on-1 Training in exactly how to use the website. Highly recommend!",
    author: "Jeremy F.",
    role: "Entrepreneur",
    project: "Website Development"
  },
  {
    id: 3,
    quote: "My business has been running on autopilot with their lead generation and appointment setting. I get daily updates and I love seeing new leads and appointments every day on my calendar.",
    author: "Brian A.",
    role: "Sales Director",
    project: "Lead Generation"
  },
  {
    id: 4,
    quote: "Our company's social media numbers are blowing over the roof! The videos are awesome and the photo shoots are so much fun! I highly recommend Mobyle services!",
    author: "Debbie G.",
    role: "Marketing Manager",
    project: "Social Media Marketing"
  },
  {
    id: 5,
    quote: "These folks are AMAZING! Reliable, and quick project delivery time. Best marketing agency and personal service!",
    author: "Maurice W.",
    role: "CEO",
    project: "Full Service"
  }
];

export const partners = [
  { id: 1, name: "Design Rush", logo: "designrush" },
  { id: 2, name: "Clutch", logo: "clutch" },
  { id: 3, name: "Awwwards", logo: "awwwards" },
  { id: 4, name: "CSS Design Awards", logo: "cssda" }
];

export const awards = [
  "Small Business Tech Company of the Year",
  "Top Marketing Agency by Design Rush",
  "Featured on Fox Business",
  "Patriot Award Recipient by CCRP"
];

export const valueProps = [
  {
    id: 1,
    number: "01",
    title: "Strategy with impact.",
    description: "We build immersive, brand-led digital experiences that wow and work hard. The kind that raises eyebrows, sparks emotion, and moves people to act."
  },
  {
    id: 2,
    number: "02",
    title: "Nail the process.",
    description: "We're collaborative, decisive, and clear from day one. You'll feel the momentum. You'll know where you stand. You'll have a team that knows when to lead, and when to listen."
  },
  {
    id: 3,
    number: "03",
    title: "Build to scale.",
    description: "We're ready for your growth. In fact, we're rooting for it. Whether it's a new campaign, product, or pivot, we make sure your digital presence is set up to flex with you."
  },
  {
    id: 4,
    number: "04",
    title: "Create to convert.",
    description: "We sweat the small stuff. From brand visuals to UX flow, every decision is intentional—designed to boost engagement, drive conversions, and build brand equity."
  }
];

export const faqs = [
  {
    id: 1,
    question: "How much does digital marketing typically cost?",
    answer: "Our projects vary based on scope and services needed. We offer flexible packages starting from retainer-based monthly services to one-time project fees. We prefer to understand your goals first and then recommend a tailored solution that fits your budget."
  },
  {
    id: 2,
    question: "How long does a website project usually take?",
    answer: "A typical website design and development project takes 8-12 weeks, depending on complexity. Brand development projects can add 4-6 weeks. We always provide clear timelines and milestones at project kickoff."
  },
  {
    id: 3,
    question: "Can you accommodate tight deadlines?",
    answer: "Absolutely! We're ready to mobilize our team and prioritize essentials to turn your project around quickly. Flexibility and focus are key to ensuring your project crosses the finish line on time."
  },
  {
    id: 4,
    question: "What ongoing support do you offer post-launch?",
    answer: "We offer comprehensive post-launch support including website maintenance, performance monitoring, content updates, and ongoing marketing services. Think of us as your long-term digital partner."
  },
  {
    id: 5,
    question: "How do you handle revisions and feedback?",
    answer: "Your feedback is essential to our process. We incorporate your thoughts and refinements at each stage, ensuring the final product exceeds expectations. Our process is built on collaboration and clear communication."
  }
];
